'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * it-header-cell
 */
ngModule.directive('itHeaderCell', function () {
  return {
    restrict: "A",
    require: "^infiniTable",
    scope: true,
    link: function link($scope, $el, $attrs, tableCtrl) {
      var column = $scope.column;
      var context = tableCtrl.getContext();
      if (column && column.id) {
        $el.attr('data-col-id', column.id);
      }
      if (column.column.subtotalGroup) {
        addSubtotalFeature();
      }
      if (column.sortable) {
        addSortableFeature();
      }
      if (column.column.tooltip) {
        addTooltipFeature();
      }
      function addTooltipFeature() {
        var tooltipContainer = $("<div>").addClass("it-tooltip-content").html(column.column.tooltip).appendTo($el);
        $el.addClass("it-has-tooltip");
        $el.find(".it-title-container").qtip({
          content: {
            text: tooltipContainer
          },
          show: {
            delay: 450
          },
          position: {
            // se passe mal dès que la page est trop longue - mais a priori inutile donc on met en commentaire
            //container : $el.closest(".infini-table"),
            my: 'top center',
            at: 'bottom center',
            adjust: {
              y: 8
            }
          },
          style: {
            classes: 'qtip-it-header'
          }
        });
        $el.find(".it-title-container").append('<i class="tooltip-info-icon fa fa-info-circle no-print"></i>');
      }
      function addSubtotalFeature() {
        var context = tableCtrl.getContext();
        function isSubtotalColumn() {
          return context.subtotal && context.subtotal.column != null && context.subtotal.column === (_.isNumber(context.subtotal.column) ? column.index : column.id);
        }
        $el.addClass("it-subtotal-column");
        var subtotalIcon = $("<i>").addClass("it-subtotal").prependTo($el);
        subtotalIcon.qtip({
          content: {
            text: isSubtotalColumn() ? 'Dégrouper' : 'Grouper'
          },
          show: {
            delay: 450,
            solo: true
          },
          position: {
            // se passe mal dès que la page est trop longue - mais a priori inutile donc on met en commentaire
            //container : $el.closest(".infini-table"),
            my: 'top center',
            at: 'bottom center',
            adjust: {
              y: 8
            }
          },
          style: {
            classes: 'qtip-it-header'
          }
        });
        subtotalIcon.click(function (event) {
          $scope.$apply(function () {
            tableCtrl.subTotalBy(column.id || column.index);
            // todo regarder dans le context sort colomn
            tableCtrl.sortBy(column.id || column.index, isSortColumn() ? context.sort.desc : false);
            // todo - nécessaire ?
            tableCtrl.refreshColumnsSizing();
            tableCtrl.refreshContent();

            // todo - utile ?
            _.delay(function () {
              $scope.$broadcast("$redraw");
              $scope.$apply();
            }, 200);
          });
          event.stopPropagation();
        });
        $scope.$watch(function () {
          return context.subtotal;
        }, function (subtotal) {
          if (isSubtotalColumn()) {
            subtotalIcon.addClass("it-subtotal-by");
          } else {
            subtotalIcon.removeClass("it-subtotal-by");
          }
        }, true);
      }
      function isSortColumn() {
        return context.sort.column === (_.isNumber(context.sort.column) ? column.index : column.id);
      }
      function addSortableFeature() {
        $el.addClass("it-sortable-column");
        var sortIcon = $("<i>").addClass("it-sort").appendTo($el);
        if (column.column.subtotalGroup) {
          sortIcon.addClass("it-sortable-column-with-subtotalgroup");
        }
        $el.click(function () {
          if ($el.data('it-just-dragged')) {
            $el.removeData('it-just-dragged');
            return;
          }
          $scope.$apply(function () {
            tableCtrl.sortBy(column.id || column.index, isSortColumn() ? !context.sort.desc : false);
          });
        });
        $scope.$watch(function () {
          return context.sort;
        }, function (sort) {
          if (isSortColumn()) {
            sortIcon.addClass("it-sorted-by");
            if (sort.desc) {
              sortIcon.removeClass("it-sort-asc").addClass("it-sort-desc");
            } else {
              sortIcon.removeClass("it-sort-desc").addClass("it-sort-asc");
            }
          } else {
            sortIcon.removeClass("it-sorted-by it-sort-asc it-sort-desc");
          }
        });
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/common/itHeaderCell.js
// module id = 2796
// module chunks = 13